import styles from './OfferHeading.module.css';

export const OfferHeading = ({
  title,
  subtitle,
}: {
  title?: string;
  subtitle?: string | null;
}) => {
  return (
    <div className={styles.container}>
      {title && <h1 className={styles.headingTitle}>{title}</h1>}
      {subtitle && <p className={styles.headingSubTitle}>{subtitle}</p>}
    </div>
  );
};
